import { Component, effect, input, computed, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@ui/icon/icon.component';
export interface TimelineItem {
  title?: string;
  date?: string;
  content: string;
  badges?: Array<{
    label: string;
    color: string;
    icon?: string;
  }>;
  variant?: 'green' | 'blue';
  status?: 'open' | 'closed';
  color?: string;
  onClick?: () => void;
}

@Component({
  selector: 'ui-timeline',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div class="relative">
      <!-- Doorlopende timeline lijn -->
      <div
        class="absolute left-0 top-0 bottom-0 w-4 flex flex-col justify-center items-center"
      >
        <div class="absolute top-0 bottom-0 bg-gray-200 w-0.5"></div>
      </div>

      @for (item of sortedItems(); track $index) {
      <div class="mb-8 relative" [ngClass]="{ 'cursor-pointer': item.onClick }">
        <!-- Content met bolletje op de lijn -->
        <div class="flex gap-2" (click)="item.onClick?.()">
          <!-- Timeline dot op de lijn -->
          <div class="relative w-4 shrink-0">
            <div
              class="absolute left-0 top-4 w-4 h-4 rounded-full border-2 border-white shadow-sm z-1"
              [ngClass]="[
                item.status === 'closed'
                  ? 'bg-green-500'
                  : item.status === 'open'
                  ? 'bg-blue-500'
                  : item.color || 'bg-primary-500'
              ]"
            ></div>
          </div>

          <!-- Content -->
          <div
            class="flex-1 bg-white p-5 rounded-lg shadow-sm border border-secondary-100 hover:shadow-md transition-shadow"
          >
            <div class="flex flex-row gap-2 justify-between items-center">
              @if (item.title) {
              <h4 class="font-semibold text-gray-900">{{ item.title }}</h4>
              } @if (item.date && showTime) {
              <span class="text-sm text-gray-500 whitespace-nowrap">
                {{ item.date | date : 'dd-MM-yyyy HH:mm' }}
              </span>
              } @if (item.date && !showTime) {
              <span class="text-sm text-gray-500 whitespace-nowrap">
                {{ item.date | date : 'dd-MM-yyyy' }}
              </span>
              }
            </div>

            @if (item.content) {
            <div class="text-sm text-gray-600 leading-relaxed mt-2">
              {{ item.content }}
            </div>
            } @if (item.badges?.length) {
            <div class="flex flex-row gap-2 mt-3">
              @for (badge of item.badges; track badge.label) {
              <span
                class="text-xs px-2.5 py-1 rounded-full font-medium transition-colors"
                [ngClass]="badge.color"
                >
                @if (badge.icon) {
                <ui-icon [name]="badge.icon"></ui-icon>
                }
                {{ badge.label }}
                </span
              >
              }
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
  `,
  styles: `
    :host {
      display: block;
      @apply py-4;
    }
  `,
})
export class TimelineComponent {
  private _items: TimelineItem[] = [];
  @Input() showTime: boolean = true;

  items = input.required<TimelineItem[]>();
  sortedItems = computed(() => {
    return this.items()
      .slice()
      .sort((a, b) => {
        if (!a.date || !b.date) return 0;
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });
  });

  constructor() {
    // effect(() => {
    //   this._items = this.items();
    //   console.log(this._items);
    // });
  }

  // @Input({ required: true })
  // set items(value: TimelineItem[]) {
  //   this._items = value.sort((a, b) => {
  //     if (!a.date || !b.date) return 0;
  //     return new Date(b.date).getTime() - new Date(a.date).getTime();
  //   });
  // }

  // get items(): TimelineItem[] {
  //   return this._items;
  // }
}
